module.exports = __webpack_public_path__ + "img/section4_3.82e71ef1.png";